module.exports = __webpack_public_path__ + "static/media/cervical-ripening-balloon-stylet-product@3x.0739c952.jpg";